<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
                     :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
                     :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex"
                     :sub-form-row-id="subFormRowId">
    <div class="period">
      <el-select v-model="fieldModel.type" class="full-width-input"
                 :disabled="field.options.disabled"
                 :size="field.options.size"
                 :clearable="field.options.clearable"
                 :filterable="field.options.filterable"
                 :allow-create="field.options.allowCreate"
                 :default-first-option="allowDefaultFirstOption"
                 :automatic-dropdown="field.options.automaticDropdown"
                 :multiple="field.options.multiple" :multiple-limit="field.options.multipleLimit"
                 :placeholder="field.options.placeholder || i18nt('render.hint.selectPlaceholder')"
                 :remote="field.options.remote" :remote-method="remoteMethod"
                 @focus="handleFocusCustomEvent" @blur="handleBlurCustomEvent"
                 >
        <el-option v-for="item in field.options.optionItems" :key="item.value" :label="item.label"
                   :value="item.value" :disabled="item.disabled">
        </el-option>
      </el-select>
      <div class="date" v-if="valueName">
        <!--     label   -->
        <span v-if="valueName != '自定义'">
          {{ valueName }}{{ valueName.indexOf('季') != -1 ? '第' : '' }}
        </span>
        <span v-else>
          每隔
        </span>
        <!--    月、日、周、时间、自定义天数    -->
        <template v-if="valueName.indexOf('自定义') != -1">
          <el-input style="width: 50px;" v-model="fieldModel.custom"></el-input>
          <span>天</span>
        </template>

        <template v-if="valueName.indexOf('每年') != -1">
          <el-select v-model="fieldModel.month" placeholder="请选择"
                     style="width: 100px">
            <el-option
                v-for="(item, i) in monthList"
                :key="i"
                :label="item.value"
                :value="item.id">
            </el-option>
          </el-select>
          <span>月</span>
        </template>

        <template v-if="valueName.indexOf('每半年') != -1">
          <el-select v-model="fieldModel.halfYear" placeholder="请选择"
                     style="width: 100px">
            <el-option
                v-for="(item, i) in halfYearList"
                :key="i"
                :label="item.value"
                :value="item.id">
            </el-option>
          </el-select>
          <span>月</span>
        </template>

        <template v-if="valueName.indexOf('季') != -1">
          <el-select v-model="fieldModel.quarter" placeholder="请选择"
                     style="width: 100px">
            <el-option
                v-for="(item, i) in 3"
                :key="i"
                :label="item"
                :value="(item).toString()">
            </el-option>
          </el-select>
          <span>月</span>
        </template>

        <template v-if="valueName.indexOf('年') != -1 || valueName.indexOf('季') != -1 || valueName.indexOf('月') != -1">
          <el-select v-model="fieldModel.day" placeholder="请选择"
                     style="width: 100px">
            <el-option
                v-for="(item, i) in dayList"
                :key="i"
                :label="item.value"
                :value="item.id">
            </el-option>
          </el-select>
          <span>日</span>
        </template>

        <template v-if="valueName.indexOf('周') != -1">
          <el-select v-model="fieldModel.week" placeholder="请选择"
                     style="width: 100px">
            <el-option
                v-for="(item, i) in weekList"
                :key="i"
                :label="item.value"
                :value="item.id">
            </el-option>
          </el-select>
          <span></span>
        </template>

        <el-time-picker
            v-if="valueName.indexOf('不定期') == -1"
            v-model="fieldModel.date"
            style="width: 120px;"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            placeholder="任意时间点">
        </el-time-picker>
        <el-date-picker
            v-else
            type="dates"
            v-model="fieldModel.datas"
            format="yyyy-MM-DD"
            value-format="yyyy-MM-DD"
            placeholder="选择一个或多个日期" />
      </div>
    </div>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from './form-item-wrapper'
import emitter from '@/utils/emitter'
import i18n, {translate} from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";

export default {
  name: "period-widget",
  componentName: 'FieldWidget',  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false
    },

    subFormRowIndex: { /* 子表单组件行索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormColIndex: { /* 子表单组件列索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormRowId: { /* 子表单组件行Id，唯一id且不可变 */
      type: String,
      default: ''
    },

  },
  components: {
    FormItemWrapper,
  },
  inject: ['refList', 'formConfig', 'globalOptionData', 'globalModel'],
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: {},
      rules: [],
    }
  },
  computed: {
    allowDefaultFirstOption() {
      return (!!this.field.options.filterable && !!this.field.options.allowCreate)
    },

    remoteMethod() {
      if (!!this.field.options.remote && !!this.field.options.onRemoteQuery) {
        return this.remoteQuery
      } else {
        return undefined
      }
    },
    valueName() {
      return this.field.options.optionItems.filter(e => e.value === this.fieldModel.type)?.[0]?.label
    },
    monthList() {
      let list = [];
      for (let i = 1; i <= 12; i++) {
        list.push({
          id: (i).toString(),
          value: i
        })
      }
      return list;
    },
    dayList() {
      let list = [];
      for (let i = 1; i <= 31; i++) {
        list.push({
          id: (i).toString(),
          value: i
        })
      }
      return list;
    },
    weekList() {
      let list = [];
      let weeks = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
      weeks.forEach((e, i) => {
        list.push({
          id: (i + 1).toString(),
          value: e
        })
      })
      return list;
    },
    halfYearList() {
      let list = [];
      for (let i = 1; i <= 6; i++) {
        list.push({
          id: (i).toString(),
          value: i
        })
      }
      return list;
    }
  },
  beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
       需要在父组件created中初始化！！ */
    this.initOptionItems()
    this.initFieldModel()
    this.registerToRefList()
    this.initEventHandler()
    this.buildFieldRules()

    this.handleOnCreated()
  },

  mounted() {
    this.handleOnMounted()
  },

  beforeDestroy() {
    this.unregisterFromRefList()
  },
  watch: {
    'fieldModel.type': {
      handler(val, val1) {
        this.fieldModel.date = '16:00:00'
      },
      deep: true
    },
    fieldModel: {
      handler(val, val1) {
        this.handleChangeEvent(val);
      },
      deep: true
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/global.scss"; //* form-item-wrapper已引入，还需要重复引入吗？ *//
.el-select {
  width: 100px;
}

.period {
  display: flex;
  align-items: center;

  .date {
    display: flex;
    align-items: center;
    margin-left: 20px;

    span {
      margin: 0 10px;

      &:first-child {
        color: #999;
      }
    }
  }
}

</style>
